import { IResponseProps } from '@/entities/Response'
import { IRoomProps } from '@/entities/Room'

export const Types = {
  store: 'store',
  talk: 'talk',
  current: 'current',
  top: 'top',
  scrollTops: 'scrollTops',
  snapshot: 'snapshot',
  filter: 'filter',
  refresh: 'refresh',
  priority: 'priority'
}

export const path = 'room/'

export class Store implements FluxStandardAction<IResponseProps<IRoomProps>> {
  type = path + Types.store
  constructor(public payload: IResponseProps<IRoomProps>) {}
}

export class Talk implements FluxStandardAction<IResponseProps<IRoomProps>> {
  type = path + Types.talk
  constructor(public payload: IResponseProps<IRoomProps>) {}
}

export class Current implements FluxStandardAction<IRoomProps | null> {
  type = path + Types.current
  constructor(public payload: IRoomProps | null) {}
}

export class Top implements FluxStandardAction<IRoomProps | null> {
  type = path + Types.top
  constructor(public payload: IRoomProps | null) {}
}

export class ScrollTops implements FluxStandardAction<{ [key: string]: number }> {
  type = path + Types.scrollTops
  constructor(public payload: { [key: string]: number }) {}
}

export class Snapshot implements FluxStandardAction<IResponseProps<IRoomProps> | null> {
  type = path + Types.snapshot
  constructor(public payload: IResponseProps<IRoomProps> | null) {}
}

export class Filter implements FluxStandardAction<string> {
  type = path + Types.filter
  constructor(public payload: string) {}
}

export class Refresh implements FluxStandardAction<void> {
  type = path + Types.refresh
  constructor() {}
}

export class Priority implements FluxStandardAction<string | null> {
  type = path + Types.priority
  constructor(public payload: string | null) {}
}
